// Keep the compact chat below the client header, reducing its offset on shorter viewports.
export const COMPACT_MESSENGER_TOP_OFFSET = 'min(200px, 24dvh)'
// Place the body-portaled panel above the existing message popover layer (999).
export const COMPACT_MESSENGER_Z_INDEX = 1000
